import { Switch as Toggle } from '@headlessui/react';
import { Fragment } from 'react';
import { useTheme } from 'styled-components';

interface IProps {
  label?: string;

  isToggled: boolean;

  onToggle?: (state: boolean) => void;
}

export const Switch: React.FC<IProps> = ({ label, isToggled, onToggle }) => {
  // custom hook to extract the current theme from Theme context
  const t: any = useTheme();
  const theme = t.current;

  return (
    <div className="flex justify-between w-full">
      <div>{label}</div>
      <Toggle as={Fragment} checked={isToggled} onChange={onToggle}>
        {({ checked }) => (
          /* Use the `checked` state to conditionally style the button. */
          <button
            className={`${
              checked ? `bg-${theme}-primary` : 'bg-gray-200'
            } relative inline-flex h-6 w-11 items-center rounded-full`}
          >
            <span className="sr-only">Enable notifications</span>
            <span
              className={`${
                checked ? 'translate-x-6' : 'translate-x-1'
              } inline-block h-4 w-4 transform rounded-full bg-white transition`}
            />
          </button>
        )}
      </Toggle>
    </div>
  );
};
